//#region Styles
import { Container } from "./styles";
//#endregion

const DataField = ({ 
    field, description, 
    direction, render,
    mini = false
}) => {
    return (
        <Container className={mini ? "mini" : ""} 
            direction={direction}>
            {field && <h4>{field}</h4>}
            {description && <span data-role="description">{description}</span>}
            {render}
        </Container>
    );
}

export default DataField;